<template>
  <div class="navbar" ref="navbar">
    <div class="navbar-left" />
    <div class="navbar-right">
      <!-- <div class="dropdown">
        <button type="button" class="dropbtn" @click="toggleDropdown('language')">
          {{ currentLanguageName }}
        </button>
        <div class="dropdown-content" ref="languageDropdown" v-if="isLanguageDropdownOpen">
          <a href="#" @click="setLanguage('zh-TW')">繁體中文</a>
          <a href="#" @click="setLanguage('en')">English</a>
        </div>
      </div> -->
      <div class="user-info">
        <span class="nickname">{{ user.nickname }}</span>
        <span class="role">({{ user.pname }})</span>
        <button type="button" @click="logout">{{ $t('logout') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';

export default {
  setup() {
    const router = useRouter();
    const id = ref(0);
    const nickname = ref('');
    const permission = ref(999);
    const isLanguageDropdownOpen = ref(false);
    const token = Cookies.get('jwt');
    const currentTime = Date.now() / 1000;
    const getLanguageName = (langCode) => {
      const languageMap = {
        'zh-TW': '繁體中文',
        'zh-CN': '简体中文',
        'en-US': 'English',
        'ja-JP': '日本語',
      };
      return languageMap[langCode];
    };
    const closeDropdownsOutside = (event, dropdownRef) => {
      if (!event.target.closest('.dropdown')) {
        dropdownRef.value = false;
      }
    };
    if (token) {
      const decoded = jwtDecode(token);
      if (decoded.exp < currentTime) {
        router.push('/logout');
      } else {
        onMounted(() => {
          document.addEventListener('click', (event) => closeDropdownsOutside(event, isLanguageDropdownOpen));
          id.value = decoded.data.id;
          nickname.value = decoded.data.nickname;
          permission.value = decoded.data.permission;
        });
      }
    } else {
      router.push('/logout');
    }

    return {
      id,
      nickname,
      permission,
      isLanguageDropdownOpen,
      currentLanguage: localStorage.getItem('language') || 'en',
      currentLanguageName: getLanguageName(localStorage.getItem('language') || 'en'),
      user: JSON.parse(localStorage.getItem('user') || '{"user": {"nickname": "", "pname": ""}}'),
      getLanguageName,
      closeDropdownsOutside,
    };
  },
  methods: {
    logout() {
      this.$router.push('/logout');
    },
    setLanguage(language) {
      this.currentLanguage = language;
      localStorage.setItem('language', language);
      this.currentLanguageName = this.getLanguageName(language);
      this.$i18n.locale = language;
      this.isLanguageDropdownOpen = false;
    },
    toggleDropdown(type) {
      if (type === 'language') {
        this.isTimezoneDropdownOpen = false;
        this.isLanguageDropdownOpen = !this.isLanguageDropdownOpen;
      } else if (type === 'timezone') {
        this.isLanguageDropdownOpen = false;
        this.isTimezoneDropdownOpen = !this.isTimezoneDropdownOpen;
      }
    },
  },
};
</script>

<style>
.navbar {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  background-color: transparent;
  /* border-bottom: 1px solid #ccc; */
}

.logo-image {
  margin-left: 20px;
  width: 100%;
  height: 30px;
}

.navbar-right {
  display: flex;
  align-items: center;
}

.dropdown {
  position: relative;
  margin-right: 20px;
}

.dropbtn {
  background-color: transparent;
  color: #888;
  border: none;
  cursor: pointer;
}

.dropdown-content {
  position: absolute;
  background-color: #f9f9f9;
  min-width: 80px;
  border: 1px solid darkgray;
}

.dropdown-content a {
  color: black;
  padding: 8px 12px;
  text-decoration: none;
  display: block;
  font-size: small;
  border-bottom: 1px solid darkgray;
}

.dropdown-content a:hover {
  background-color: #ddd;
}

.user-info {
  display: flex;
  align-items: center;
}

.user-info span {
  margin-right: 4px;
}

.user-info .nickname {
  font-size: small;
}

.user-info .role {
  color: #888;
  font-size: small;
}

.user-info button {
  margin-left: auto;
  background-color: transparent;
  border: 1px solid #888;
  border-radius: 8px;
  cursor: pointer;
  color: #888;
  margin-left: 16px;
}
</style>
